



import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import toast from 'react-hot-toast';
import { Modal, Button } from 'react-bootstrap';

const Topbar = () => {
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleLogoutConfirm = () => {
 
    localStorage.clear();
    sessionStorage.clear();
    toast.success('Logged out successfully');

    setShowLogoutModal(false);
    setTimeout(() => {
      navigate('/admin');
    }, 1000);
  };


  


  return (
    <>
      <div className="topbar d-flex justify-content-end align-items-center px-4 py-2 bg-light border-bottom">
        <div className="admin-info d-flex align-items-center gap-3">
          <i className="fa fa-user" /> <span>Admin</span>
          <button
            className="btn btn-outline-success fw-bold btn-sm"
            onClick={() => setShowLogoutModal(true)}
          >
            Logout
          </button>
        </div>
      </div>

      {/* Logout Confirmation Modal */}
      <Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to logout?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLogoutModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleLogoutConfirm}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Topbar;
